<mat-spinner *ngIf="loadingPaymentHistory"></mat-spinner>

<div *ngIf="!loadingPaymentHistory" class="payment-history">
  <h2 class="payment-history-header">
    <div>
      <span *ngIf="payments && payments.length > 0">Payment History</span>
      <span id="paymentHistory-text-noPaymentHistory" *ngIf="payments && payments.length === 0">No Payment History</span>

      <button
        id="paymnentHistory-button-newPayment"
        class="new-payment"
        (click)="handleNewPayment()"
        mat-button
        *appRequiresPermissions="{ any: ['payment_processing'] }"
      >
        New Payment
        <i class="material-icons">
          add
        </i>
      </button>
    </div>
  </h2>
  <table
    id="paymentHistory-table-payments"
    *ngIf="payments && payments.length > 0"
    mat-table
    [dataSource]="chargeDataSource"
    multiTemplateDataRows
    class="mat-elevation-z8"
  >
    <ng-container matColumnDef="processedAmount">
      <th width="15%" mat-header-cell *matHeaderCellDef>Processed Amount</th>
      <td id="paymentHistory-text-processedAmount-{{ payment.id }}" mat-cell *matCellDef="let payment">{{ payment.processedAmount | currency }}</td>
    </ng-container>

    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef>Original Amount</th>
      <td id="paymentHistory-text-originalAmount-{{ payment.id }}" mat-cell *matCellDef="let payment">{{ payment.amount | currency }}</td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef>Date</th>
      <td id="paymentHistory-text-date-{{ payment.id }}" mat-cell *matCellDef="let payment">{{ payment.createdDate | date: 'short' }}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th class="status" mat-header-cell *matHeaderCellDef>Status</th>
      <td id="paymentHistory-text-status-{{ payment.id }}" class="status" mat-cell *matCellDef="let payment">{{ payment.paymentStatus.name }}</td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th class="description" mat-header-cell *matHeaderCellDef>Description</th>
      <td id="paymentHistory-text-description-{{ payment.id }}" class="description" mat-cell *matCellDef="let payment">{{ payment.paymentDescription }}</td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let payment">
        <span *ngIf="paymentAccounts && paymentAccounts.length > 0" class="expand">
          <mat-icon
            id="paymentHistory-button-expandDetails-{{ payment.id }}"
            class="expand_more"
            (click)="handleExpandPayment(payment)"
            [@indicatorRotate]="payment == expandedPayment ? 'open' : 'closed'"
          >
            expand_more
          </mat-icon>
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="paymentDetails">
      <td mat-cell *matCellDef="let payment" [attr.colspan]="paymentColumns.length">
        <div class="payment-detail" [@detailExpand]="payment === expandedPayment ? 'expanded' : 'collapsed'">
          <div class="actions-payment-info">
            <span
              ><small>Card:</small>
              <span id="paymentHistory-text-cardDetails-{{ payment.id }}">
                {{ payment.paymentAccount.cardType.name }} ending in {{ payment.paymentAccount.cardNumber }} &nbsp; [{{
                  payment.paymentAccount.cardExpiration
                }}]</span
              >
            </span>
            <span
              *ngIf="
                expandedPaymentTransactions &&
                expandedPaymentTransactions[0] &&
                expandedPaymentTransactions[0].id &&
                !expandedPaymentTransactions[0].payment.paymentAccount.active
              "
              class="action-buttons"
            >
              Payment account is not active
            </span>
            <span
              *ngIf="
                expandedPaymentTransactions &&
                expandedPaymentTransactions[0] &&
                expandedPaymentTransactions[0].id &&
                expandedPaymentTransactions[0].payment.paymentAccount.active
              "
              class="action-buttons"
            >
              <span>
                <button
                  id="paymentHistory-button-edit-{{ payment.id }}"
                  mat-stroked-button
                  color="primary"
                  (click)="handleEditPaymentAccount(payment.paymentAccount)"
                >
                  Edit
                </button>
              </span>
              <span
                *ngIf="
                  expandedPaymentTransactions &&
                  expandedPaymentTransactions[0].transactionStatus.name === 'Approved' &&
                  expandedPaymentTransactions[0].settled === true
                "
              >
                <button
                  id="paymentHistory-button-refund-{{ payment.id }}"
                  class="refund"
                  (click)="handleRefund(payment)"
                  mat-stroked-button
                  color="primary"
                  *appRequiresPermissions="{ any: ['payment_processing'] }"
                >
                  Refund
                </button>
              </span>
              <span
                *ngIf="
                  expandedPaymentTransactions &&
                  expandedPaymentTransactions[0].transactionStatus.name === 'Approved' &&
                  expandedPaymentTransactions[0].settled === false &&
                  payment.paymentStatus.name !== 'Voided' &&
                  payment.paymentStatus.name !== 'Refunded'
                "
              >
                <button
                  id="paymentHistory-button-void-{{ payment.id }}"
                  class="void"
                  (click)="handleVoidPayment(payment)"
                  mat-stroked-button
                  color="primary"
                  *appRequiresPermissions="{ any: ['payment_processing'] }"
                >
                  Void
                </button>
              </span>
              <span
                *ngIf="
                  (expandedPaymentTransactions && expandedPaymentTransactions[0].transactionStatus.name === 'Error') ||
                  (expandedPaymentTransactions && expandedPaymentTransactions[0].transactionStatus.name === 'Declined')
                "
              >
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="handleResubmit(payment)"
                  *appRequiresPermissions="{ any: ['payment_processing'] }"
                >
                  Resubmit
                </button>
              </span>
            </span>
          </div>

          <mat-spinner class="chat-messages-loading-spinner" *ngIf="loadingTransactions"></mat-spinner>
          <mat-card appearance="outlined" *ngIf="!loadingTransactions">
            <div class="payment-transactions">
              <mat-card-title><h3>Transactions</h3></mat-card-title>
              <mat-card-content>
                <table id="paymentHistory-table-paymentTransactions-{{ payment.id }}">
                  <tr>
                    <th>ID</th>
                    <th>Date</th>
                    <th>Amount</th>
                    <th>Transaction Type</th>
                    <th>Status</th>
                  </tr>
                  <tr id="paymentHistory-row-paymentTransaction-{{paymentTransaction.id}}" *ngFor="let paymentTransaction of expandedPaymentTransactions">
                    <td>{{ paymentTransaction.id }}</td>
                    <td>{{ paymentTransaction.createdDate | date: 'short' }}</td>
                    <td id="paymentHistory-row-paymentTransactionAmount-{{paymentTransaction.id}}">{{ paymentTransaction.amount | currency }}</td>
                    <td>{{ paymentTransaction.transactionType.name }}</td>
                    <td>{{ paymentTransaction.transactionStatus.name }}</td>
                  </tr>
                </table>
              </mat-card-content>
            </div>
          </mat-card>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="paymentColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: paymentColumns"
      class="payment-row"
      [class.payment-expanded-row]="expandedPayment === row"
    ></tr>
    <tr mat-row *matRowDef="let row; columns: ['paymentDetails']" class="payment-detail-row"></tr>
  </table>
</div>
<mat-paginator
  #paymentHistoryResultsPaginator
  [style.display]="'inherit'"
  [length]="10000"
  [pageSize]="20"
  [pageSizeOptions]="[10, 20, 30]"
  (page)="handlePageChange($event)"
>
</mat-paginator>
